var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trackOrderData)?_c('section',{staticClass:"order-details"},[_c('OrderDetails',{staticClass:"container",attrs:{"orderDetailsData":_vm.trackOrderData}})],1):_c('loader')}
var staticRenderFns = []

export { render, staticRenderFns }